<template>
  <div class="page">
    <p class="title" data-cy="contact-us-title">
      {{ $t('contacts["Need to speak to someone? Contact us!"]') }}
    </p>
    <div class="contact-list" data-cy="contact-list">
      <div class="list-container">
        <contact-card
          v-for="contactCard in contactCards"
          :key="contactCard.id"
          class="contact-card"
          :iso-country="contactCard.isoCountry"
          :telephone-number="contactCard.telephoneNumber"
          :email-address="contactCard.emailAddress"
          :country-name="contactCard.countryName" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { default as ContactCard, type ContactCardProps } from '@/components/contact/contact-card.vue';
import { ContactService } from '@/services/contacts.service';
import type { LocalizedString } from '@onrunning/backstage-models';
import { defineComponent } from 'vue';
import { useLocale } from '../composables/locale';
import type { Contact } from '../models/contact.model';

// TODO: country code should come from backend
const countryNameToISOCountryMap: Record<string, string> = {
  Benelux: 'nl',
  Switzerland: 'ch',
  France: 'fr',
  'United Kingdom': 'gb',
  Germany: 'de',
  Austria: 'at',
  Brazil: 'br',
  Australia: 'au',
  Canada: 'ca',
  'United States': 'us',
  Japan: 'jp',
  China: 'cn',
  Spain: 'es',
};

export default defineComponent({
  name: 'contacts-list',
  components: {
    ContactCard,
  },
  setup() {
    const { userLanguage } = useLocale();

    return {
      userLanguage,
    };
  },
  data() {
    return {
      contacts: new Array<Contact>(),
      contactsService: new ContactService(),
    };
  },
  mounted() {
    this.fetchContacts();
  },
  computed: {
    contactCards(): Array<ContactCardProps> {
      return this.contacts.map<ContactCardProps>((contact) => ({
        emailAddress: contact.emailAddress,
        telephoneNumber: contact.telephoneNumber,
        countryName: contact.countryName[this.userLanguage as keyof LocalizedString],
        isoCountry: countryNameToISOCountryMap[contact.countryName['en-US']],
      }));
    },
  },
  methods: {
    async fetchContacts() {
      this.contacts = await this.contactsService.getAll();
    },
  },
});
</script>

<style scoped lang="scss">
.page {
  padding: 2.5rem 1.25rem;
  max-width: 1366px;
  margin: 0 auto;

  .title {
    text-align: left;
    font-size: 1.25rem;
  }

  .contact-list {
    .list-container {
      display: grid;
      gap: 0 20px;
      grid-template-columns: 1fr 1fr;

      @include breakpoint(small) {
        grid-template-columns: 1fr;
      }

      .contact-card {
        margin: 0 0 1px 0;

        &:first-of-type,
        &:nth-child(2) {
          border-radius: 4px 4px 0 0;
        }

        &:nth-last-child(1),
        &:nth-last-child(2) {
          border-radius: 0 0 4px 4px;
        }
      }
    }
  }
}
</style>
